export const CatalogStatusErrors = {
  NoMatchingOffers: _TL_('No matching products'),
  AuthorizationError: _TL_('Authorization error'),
  ExceedImportSizeLimit: _TL_('Import size limit'),
  InternalError: _TL_('Internal error'),
};
